
<template>
	<div>
		<CommonFlame :title="title">
			<div>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="order_individual_infos"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="openDialog(item.id)">
								<td>
									{{ common.productNameWithSubName(item.ordered_product) }}
								</td>
								<td>{{ item.ordered_product.product.product_code }}</td>
								<td>{{ common.productNumberByOrderIndividualInfo(item) }}</td>
								<td>{{ item.quantity }}</td>
							</tr>
						</template>
					</v-data-table>

					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
			</div>
		</CommonFlame>
		<OrderIndividualInfoShowDialog :dialog.sync="dialog" :id="selectedId" />
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import PaginationModule from "../../modules/PaginationModule.vue"
import OrderIndividualInfoShowDialog from "./components/OrderIndividualInfoShowDialog.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		OrderIndividualInfoShowDialog,
	},
	data() {
		return {
			title: "製品在庫一覧",
			headers: [
				{
					text: "製品名",
					value: "name",
					width: "150px",
				},
				{
					text: "製品番号",
					value: "product_code",
					width: "150px",
				},
				{
					text: "製造番号",
					value: "product_code",
					width: "150px",
				},
				{
					text: "数量",
					value: "quantity",
					width: "80px",
				},
			],
			order_individual_infos: [],
			selectedId: null,
			dialog: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			common,
		}
	},
	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchOrderIndividualInfos(page)
	},
	methods: {
		fetchOrderIndividualInfos(page) {
			const headers = authenticate.setHeader()
			const url = "/erp/v1/order_individual_infos/stocks"
			const params = { page }
			axios
				.get(url, {
					headers,
					params,
				})
				.then((res) => {
					this.order_individual_infos = res.data.order_individual_infos
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			this.fetchCheckSheets(i)
			this.$router.push({
				name: this.$route.name,
				query: { page: i },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		openDialog(id) {
			this.selectedId = id
			this.dialog = true
		},
	},
	computed: {},
}
</script>
